export class SliderContentStyle {
  size = 'uk-h5';
  font = 'tb-font-primary';
  marginTop = 'uk-margin-top';
  transition = '';

  static normalize(styles: Partial<SliderContentStyle>): SliderContentStyle {
    const pureStyles = new SliderContentStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.transition = styles.transition ?? pureStyles.transition;

    return pureStyles;
  }
}
